export default __webpack_public_path__ + "static/media/img-highfive-light.205bb7c8.svg";